import {
  SavePerson_Input,
  useSavePersonFormQuery,
  useSavePersonMutation
} from 'generated/graphql';
import React, { useEffect } from 'react';
import { appFormUtil } from 'modules/common';



type IFormState = {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  preferredEmail: string;
  apiFileId: string;
  profileApiFileUrl: string;
};

const initialState: IFormState = {
  id: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  preferredEmail: '',
  apiFileId: '',
  profileApiFileUrl: ''
};

export function useFormState() {
  const {
    formState,
    dispatch,
    genFieldProps
  } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      id: {
        label: 'id',
        type: 'text'
      },
      firstName: {
        label: 'First Name',
        type: 'text'
      },
      lastName: {
        label: 'Last Name',
        type: 'text'
      },
      phoneNumber: {
        label: 'Phone Number',
        type: 'text'
      },
      preferredEmail: {
        label: 'Preferred Email',
        type: 'email'
      },
      apiFileId: {
        label: 'apiFileId',
        type: 'text'
      },
      profileApiFileUrl: {
        label: 'profileApiFileUrl',
        type: 'text'
      }
    }
  });

  const { data, loading, called } = useQuery();
  useEffect(() => {
    if (data && !loading && called && formState.id === '') {
      dispatch({
        type: 'BATCH_UPDATE',
        payload:
        {
          ...formState,
          ...data
        }
      });
    }
  });

  return React.useMemo(
    () => {
      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}

export interface IData extends IFormState {}

export function useQuery() {
  const tuple = useSavePersonFormQuery();

  return React.useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.loggedInUser?.person.id ?? '',
        firstName: tuple.data?.loggedInUser?.person.firstName ?? '',
        lastName: tuple.data?.loggedInUser?.person.lastName ?? '',
        phoneNumber: tuple.data?.loggedInUser?.person.phoneNumber ?? '',
        preferredEmail: tuple.data?.loggedInUser?.person.preferredEmail ?? '',
        apiFileId: tuple.data?.loggedInUser?.person.profilePicture?.id ?? '',
        profileApiFileUrl: tuple.data?.loggedInUser?.person.profilePicture?.url ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSavePerson() {
  const [
    fnMutate,
    tuple
  ] = useSavePersonMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (input: SavePerson_Input) => {
      await fnMutate({
        variables: {
          input: {
            ...input
          }
        }

      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
